// ─────────────────────────────────────────────────────────────────────
// FIXTURE NAMES FOR THE DEV-ONLY DEMO GENERATOR.
//
// `BookingView`'s 🎲 button fills the selected day with fake bookings so an
// empty calendar can be looked at. These names are INVENTED — fixture data,
// not product copy — so they must never reach the message catalog (#310) and
// must never be translated: a demo booker called «Bjørn Dahl» is the same
// person in every language.
//
// They live in a `.ts` module rather than inside the component for exactly
// that reason: the raw-string guard reads `.tsx` looking for Norwegian UI
// text, and a list of Norwegian NAMES is the one thing in that file which
// looks like copy and is not.
// ─────────────────────────────────────────────────────────────────────
export const DEMO_BOOKER_NAMES = [
  'Anders Olsen',
  'Mette Kvam',
  'Lars Berg',
  'Ingrid Hansen',
  'Erik Vold',
  'Sofie Eide',
  'Magnus Nilsen',
  'Camilla Sand',
  'Henrik Lie',
  'Marit Foss',
  'Petter Ekberg',
  'Linn Solberg',
  'Jonas Holm',
  'Astrid Moen',
  'Truls Aas',
  'Birgit Nord',
  'Sondre Berg',
  'Kari Lund',
  'Olav Strand',
  'Vera Krog',
  'Tomas Riis',
  'Helene Aune',
  'Bjørn Dahl',
  'Idunn Mo',
  'Sverre Tang',
  'Aslak Foss',
  'Nora Berg',
  'Eskil Vik',
  'Ronja Eide',
  'Knut Aas',
];
